import styled from "styled-components";

import { Description } from "@evergis/ui";

export const DialogDescription = styled(Description)`
  opacity: 0.54;
  margin-top: 0.5rem;
`;

export const SliderContainer = styled.div`
  width: 100%;
  margin: 2rem 0.5rem 0;
`;
